import React, { useRef } from "react";
import styled from "styled-components";

import { Button } from "../components/atoms/Button";

const Container = styled.div`
  width: 80%;
`;

const TextBox = styled.textarea`
  width: 50%;
  min-height: 18rem;
`;

export const ImportClipboard = ({ handleImportConfirmed }) => {
  const box = useRef(null);
  return (
    <Container>
      <h3>Wklej logi z Hunt Analyzera</h3>
      <TextBox ref={box} />
      <br />
      <Button handleClick={() => handleImportConfirmed(box.current.value)}>
        Dalej
      </Button>
    </Container>
  );
};
